import type { UpdatePublicEmailDomainsBody } from '@planuze/admin-contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getPublicEmailDomains,
  updatePublicEmailDomains,
} from '../lib/public-email-domains-api.js';

/* Hooks dos domínios de email públicos (ADR-0569). Lista curada que barra domínios públicos
   como domínio `verified` de org (footgun same-domain, ADR-0325/0551). */

export function usePublicEmailDomains() {
  return useQuery({
    queryKey: ['public-email-domains'],
    queryFn: () => getPublicEmailDomains(),
  });
}

export function useUpdatePublicEmailDomains() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdatePublicEmailDomainsBody) => updatePublicEmailDomains(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['public-email-domains'] });
    },
  });
}
